export default function CDebugging() {
  return <h2>C Debugging</h2>;
}
